import { render } from "./S226028.vue?vue&type=template&id=2b4a6154"
const script = {}
script.render = render

export default script